import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

export default function ReasonDetails({ reason }) {
  return (
    <React.Fragment>
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Cancellation Reason details
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Reason name" />
            <span className="divider" />
            <ListItemText secondary={reason.name} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Reason type" />
            <span className="divider" />
            <ListItemText secondary={reason.obsoletionType} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Is Active" />
            <span className="divider" />
            <ListItemText secondary={reason.isActive} />
          </ListItem>
        </List>
      </div>
    </React.Fragment>
  );
}
